let context: AudioContext | null = null;

export function getAudioContext(): AudioContext | null {
  if (typeof AudioContext === "undefined") return null;
  context ??= new AudioContext();
  return context;
}

/**
 * A shared graph lets us control both synthesized SE and MP3 audio on mobile
 * browsers, where HTMLAudioElement.volume may be ignored.
 */
export async function getReadyAudioContext(): Promise<AudioContext | null> {
  const context = getAudioContext();
  if (!context) return null;
  if (context.state === "suspended") await context.resume();
  return context;
}
